import { State } from '..';

interface EventProps {}

interface Config<S, P, A, R> {
  nextState: number;
  sfx: any;
}

const StateSound = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  sfx,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      const audio = new Audio(sfx);
      audio.play();

      return {
        type: 'MOVE',
        nextState: nextState,
      };
    },

    nodeName: 'T.states.sound',
    outputs: [
      {
        name: 'after',
        to: nextState,
      },
    ],
  };
};

export default StateSound;
